import { Container as MuiContainer } from '@material-ui/core';
import React from 'react';

export const Container: React.FunctionComponent = ({ children }) => (
  <main>
    <div className='l-container'>
      <div>{children}</div>
    </div>
  </main>
);

export const ContainerModern: React.FC<React.ComponentProps<typeof MuiContainer>> = ({
  children,
  ...props
}) => (
  <MuiContainer
    maxWidth='lg'
    style={{
      paddingBottom: '12rem',
      paddingTop: '4rem',
      overflow: 'hidden',
    }}
    {...props}
  >
    {children}
  </MuiContainer>
);
